import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const baseClassName =
  'rounded-lg bg-white shadow flex flex-col justify-between';

export default function Panel({ children, className, useDivider, dataTestId }) {
  return (
    (<section
      data-testid={dataTestId}
      className={classnames(
        baseClassName,
        { 'divide-y': useDivider, 'divide-gray-200': useDivider },
        className,
      )}>
      {children}
    </section>)
  );
}

Panel.propTypes = {
  useDivider: PropTypes.bool,
};

Panel.defaultProps = {
  useDivider: true,
};
